import { mdiPencil } from '@mdi/js';
import i18n from 'es2015-i18n-tag';
import IconButton from '../../../common/ui-components/icon-button/icon-button.component';
import './account-edit-button.component.scss';
import { useNavigate } from 'react-router';

export interface AccountEditButtonProps {
    className?: string;
    id: string;
}

export const AccountEditButton = ({ className, id }: AccountEditButtonProps) => {
    const navigate = useNavigate();

    return (
        <IconButton
            title={i18n`Account bearbeiten`}
            role="link"
            icon={mdiPencil}
            className={className}
            onClick={e => {
                e.preventDefault();
                navigate(`/accounts/${id}/edit`);
            }}
        />
    );
};

export default AccountEditButton;
